var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',{},[_c('CCol',{attrs:{"sm":"12"}},[_c('code',[_vm._v(_vm._s(_vm.selectedLog.data))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }